import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Spin } from 'antd';
import { APP_CONFIG } from '../config';

interface AuthGuardProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

interface UserInfo {
  id: number;
  phone: string;
  nickname: string;
  role: string;
  isSuperAdmin: boolean;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, requireSuperAdmin = false }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      console.log('[AuthGuard] 开始检查权限');
      const token = localStorage.getItem(APP_CONFIG.tokenKey);
      const userStr = localStorage.getItem(APP_CONFIG.userKey);

      console.log('[AuthGuard] Token存在:', !!token);
      console.log('[AuthGuard] 用户信息存在:', !!userStr);

      if (!token || !userStr) {
        console.log('[AuthGuard] 未登录，跳转到登录页');
        message.warning('请先登录');
        navigate('/login');
        return;
      }

      try {
        const user: UserInfo = JSON.parse(userStr);
        console.log('[AuthGuard] 用户信息:', user);

        // 检查是否需要超级管理员权限
        if (requireSuperAdmin) {
          console.log('[AuthGuard] 需要超级管理员权限:', requireSuperAdmin);
          console.log('[AuthGuard] 用户是超级管理员:', user.isSuperAdmin);

          if (!user.isSuperAdmin) {
            console.log('[AuthGuard] 用户没有超级管理员权限');
            message.error('您需要超级管理员权限才能访问此页面');
            navigate('/dashboard');
            return;
          }
        }

        // 非管理员角色（retail、level1、level2、level3、regional）只能访问仪表板和业绩计算
        const nonAdminRoles = ['retail', 'level1', 'level2', 'level3', 'regional'];
        if (nonAdminRoles.includes(user.role)) {
          const currentPath = window.location.pathname;
          if (currentPath !== '/dashboard' && currentPath !== '/calculation') {
            console.log('[AuthGuard] 非管理员用户尝试访问受限页面:', currentPath);
            message.error('您没有权限访问此页面');
            navigate('/dashboard');
            return;
          }
        }

        console.log('[AuthGuard] 权限检查通过');
        setAuthorized(true);
      } catch (error) {
        console.error('[AuthGuard] 用户信息解析失败:', error);
        message.error('用户信息无效，请重新登录');
        localStorage.removeItem(APP_CONFIG.tokenKey);
        localStorage.removeItem(APP_CONFIG.userKey);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate, requireSuperAdmin]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  return authorized ? <>{children}</> : null;
};

export default AuthGuard;